import { Palette, Smartphone, Zap } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const BENEFITS = [
  {
    icon: Palette,
    title: "Moderne design",
    text: "En hjemmeside, der ser skarp og professionel ud — og som matcher den kvalitet, du leverer hver dag.",
  },
  {
    icon: Smartphone,
    title: "Mobilvenlig",
    text: "De fleste kunder finder dig på telefonen. Din side fungerer fejlfrit på mobil, tablet og computer.",
  },
  {
    icon: Zap,
    title: "Hurtig og enkel proces",
    text: "Vi tager os af alt det tekniske, så du kan fokusere på din virksomhed. Fra idé til live side uden besvær.",
  },
];

export const Benefits = () => (
  <section className="py-20 sm:py-28" data-testid="benefits-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-4">
          Hvorfor os
        </p>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900 max-w-2xl">
          En professionel hjemmeside — uden det sædvanlige besvær
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-8 md:grid-cols-3">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.12}>
            <div
              data-testid={`benefit-card-${i + 1}`}
              className="h-full bg-white border border-zinc-200/80 rounded-2xl p-8 hover:border-zinc-900 transition-colors duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-zinc-900 text-white flex items-center justify-center mb-6">
                <b.icon className="w-5 h-5" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-semibold text-zinc-900 mb-3">{b.title}</h3>
              <p className="text-base text-zinc-600 leading-relaxed">{b.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
